import React from 'react';
import {
	TopToolbar,
	sanitizeListRestProps,
	useListContext,
	usePermissions,
} from 'react-admin';

import { RefreshEntityCacheButton } from 'components/toolbars/RefreshEntityCacheButton';
import { CacheEntities } from 'entities/CacheEntities';
import { UserRole } from 'entities/UserRole';
import { SyncEntityButton } from '../../../components/toolbars/SyncEntityButton';
import { SyncEntities } from 'entities/SyncEntities';

export const TerminalsActions = (props) => {
    const { className, exporter, filters, ...rest } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        showFilter,
    } = useListContext(props);
    const { permissions } = usePermissions();
    const isAdmin = permissions?.role === UserRole.admin;

    return React.useMemo(
        () => (
            <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
				{isAdmin && (
                    <>
                        <RefreshEntityCacheButton
                            cacheEntityId={CacheEntities.terminal}
                            title='resources.terminal.buttons.refresh'
                        />
                        <SyncEntityButton
                            syncEntityId={SyncEntities.external_terminals}
                            title='resources.terminal.buttons.sync'
                        />
                    </>
                )}

				{filters &&
                    React.cloneElement(filters, {
                        resource,
                        showFilter,
                        displayedFilters,
                        filterValues,
                        context: 'button',
                    })}
            </TopToolbar>
        ),
        [resource, displayedFilters, filterValues, filters, isAdmin] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
